import EqHeight from './../eq-height/eq-height';
// Дефолтная инициализация;
(($)=>{
    var title = new EqHeight('.card-product__title');
    var subtitle = new EqHeight('.card-product__subtitle');
    var feature = new EqHeight('.card-product__feature');
    var refresh = () => {
        title.update();
        subtitle.update();
        feature.update();
    };
    refresh();
    $(document)
        .on('ready', refresh)
        .on('OnDocumentHtmlChanged', refresh)
        .on('shown.bs.modal', '.modal', refresh)
        .on('shown.bs.tab', '[data-toggle="tab"]', refresh);
    $(window).on('load resize', refresh);

    $('.product__description table:not([class])')
        .addClass('table table-bordered text-small')
        .wrapAll('<div class="table-responsive"/>');
})($);
